(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paix-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paix-buy-now')) {
    class PaixBuyNow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.pxbuynow__btn');
        this.error = this.querySelector('.pxbuynow__error');
        if (!this.button) return;
        this.onClick = this.onClick.bind(this);
        this.sync = this.sync.bind(this);
        this.button.addEventListener('click', this.onClick);
        // Follow the add to cart button (variant changes, sold out)
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.closest('.shopify-section') || document.body, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['disabled'],
        });
        document.addEventListener('variant:update', this.sync);
        // Opgave 63 B: before Horizon's variant picker (capture), so the buttons change at once
        this.onPick = this.onPick.bind(this);
        document.addEventListener('change', this.onPick, true);
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('variant:update', this.sync);
        document.removeEventListener('change', this.onPick, true);
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      get data() {
        if (this._data === undefined) {
          try {
            const el = this.querySelector('script[data-pxbuynow-data]');
            this._data = el ? JSON.parse(el.textContent) : null;
          } catch (e) {
            this._data = null;
          }
        }
        return this._data;
      }

      /**
       * Opgave 63 B: a size was tapped in this product's variant picker. Show the new state right away, from the
       * variant data on the page: ADD TO CART on/off and its text, the variant id for BUY NOW, and the stock line.
       * Horizon's own update from the server follows and sets the same state again.
       * @param {Event} event
       */
      onPick(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
        const picker = input.closest('variant-picker');
        const section = this.closest('.shopify-section');
        if (!picker || !section || !section.contains(picker)) return;
        if (picker.closest('product-card, quick-add-component, dialog')) return;
        const data = this.data;
        if (!data || !data.v || !data.t) return;
        const option = input instanceof HTMLSelectElement ? input.options[input.selectedIndex] : input;
        // Several options (e.g. colour + size): the id belongs to the tapped value with the other values that are chosen
        const id = option && option.dataset.variantId ? option.dataset.variantId : '';
        const available = !!id && data.v[id] === true;

        const form = this.form;
        const add = form && form.querySelector('button[name="add"]');
        const idInput = form && form.querySelector('input[name="id"]');
        if (idInput && id) idInput.value = id;
        if (add) {
          add.disabled = !available;
          const label = add.querySelector('.add-to-cart-text__content span span') || add.querySelector('.add-to-cart-text__content');
          if (label) label.textContent = available ? data.t.add : id ? data.t.soldout : data.t.unavailable;
          const icon = add.querySelector('.add-to-cart-icon');
          // .svg-wrapper sets display, so the hidden attribute is not enough. The server's version replaces the button later.
          if (icon) icon.style.display = available ? '' : 'none';
        }

        const inventory = section.querySelector('product-inventory');
        const stock = inventory && inventory.querySelector('script[data-px-inventory]');
        if (stock) {
          let map = null;
          try {
            map = JSON.parse(stock.textContent);
          } catch (e) {}
          const line = map && (map[id] || (!id ? { s: 'out_of_stock', t: data.t.unavailable } : null));
          if (line) {
            const iconEl = inventory.querySelector('.product-inventory__icon');
            if (iconEl) {
              iconEl.classList.remove('product-inventory__icon-low', 'product-inventory__icon-in_stock', 'product-inventory__icon-out_of_stock');
              iconEl.classList.add('product-inventory__icon-' + line.s);
            }
            const text = inventory.querySelector('.product-inventory__text');
            if (text) text.textContent = line.t;
            const status = inventory.querySelector('.product-inventory__status');
            if (status) status.style.visibility = '';
          }
        }
        this.sync();
      }

      get form() {
        const scope = this.closest('.shopify-section') || document;
        return scope.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      }

      sync() {
        const form = this.form;
        const add = form && form.querySelector('button[name="add"]');
        const id = form && form.querySelector('input[name="id"]');
        const off = !form || !add || add.disabled || !id || id.disabled || !id.value;
        if (this.button.disabled !== off && this.button.getAttribute('aria-busy') !== 'true') this.button.disabled = off;
        if (this.hidden !== off) this.hidden = off;
      }

      async onClick() {
        const form = this.form;
        const id = form && form.querySelector('input[name="id"]');
        if (!id || !id.value || this.button.disabled) return;
        const qtyInput =
          form.querySelector('input[name="quantity"]') ||
          (form.id ? document.querySelector(`input[name="quantity"][form="${form.id}"]`) : null);
        const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.error) this.error.hidden = true;
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id.value), quantity }] }),
          });
          if (!response.ok) throw new Error(String(response.status));
          window.location.href = `${root}checkout`;
        } catch (e) {
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
          if (this.error) this.error.hidden = false;
        }
      }
    }
    customElements.define('paix-buy-now', PaixBuyNow);
  }
  } catch(e) { console.error(e); }
})();

})();
